import { render, staticRenderFns } from "./print_form.vue?vue&type=template&id=6965c1c1&scoped=true&"
import script from "./print_form.vue?vue&type=script&lang=js&"
export * from "./print_form.vue?vue&type=script&lang=js&"
import style0 from "./print_form.css?vue&type=style&index=0&id=6965c1c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6965c1c1",
  null
  
)

export default component.exports